<div
  class="w-full border p-2 rounded-md bg-white shadow-sm"
  [ngClass]="{
    'border-descargo-pendiente': estado == 0,
    'border-descargo-aprobado': estado == 1,
    'border-descargo-rechazado': estado == 2
  }"
>
  <!-- Header -->
  <div
    class="relative transition-all duration-200 cursor-pointer"
    (click)="isCollapsed = !isCollapsed"
    [ngClass]="{
      'border-b pb-2': !isCollapsed,
      'border-b-descargo-pendiente': estado == 0,
      'border-b-descargo-aprobado': estado == 1,
      'border-b-descargo-rechazado': estado == 2,
    }"
  >
    <p
      [ngClass]="{
        'text-descargo-pendiente-font': estado == 0,
        'text-descargo-aprobado-font': estado == 1,
        'text-descargo-rechazado-font': estado == 2,
      }"
    >
      <b>{{ titulo }}</b>
    </p>
    <span
      class="border-b-2 h-0 block absolute right-3 top-1/2 -translate-y-1/2 transition-all duration-200 border-r-2"
      [ngClass]="{
        'w-4': isCollapsed,
        'rotate-45 h-3 w-3 top-[40%]': !isCollapsed,
        'border-descargo-pendiente-font': estado == 0,
        'border-descargo-aprobado-font': estado == 1,
        'border-descargo-rechazado-font': estado == 2,
      }"
    ></span>
  </div>
  <div class="hide" [ngClass]="{ show: !isCollapsed }">
    <div>
      <div>
        <!-- Contenido -->
        <div class="block py-2">
          <ng-template *ngTemplateOutlet="contenidoHtml"></ng-template>
        </div>
        <!-- Contenido -->

        <!-- Botonera cambio de estado -->
        @if(estado == 0) {
        <div class="flex justify-end items-center">
          <div class="p-2">
            <button
              class="mr-3 bg-primary-900 text-white rounded-md px-3 py-2"
              (click)="show(1)"
            >
              Aprobar
            </button>
            <button
              class="border border-primary-900 text-primary-900 rounded-md px-3 py-2"
              (click)="show(2)"
            >
              Rechazar
            </button>
          </div>
        </div>
        }
        <!-- Botonera cambio de estado -->
      </div>
    </div>
  </div>
</div>

@if(estado == 0) {
<p-dialog
  [(visible)]="visible"
  [draggable]="false"
  [modal]="true"
  appendTo="body"
  [closable]="true"
  [style]="{ width: '90vw' }"
  [closeOnEscape]="false"
  (onHide)="close()"
>
  <ng-template pTemplate="header">
    <div class="flex justify-start items-start flex-col">
      <h1 class="text-xl">
        <b>
          {{ newEstado == 1 ? 'Aprobar el descargo' : 'Rechazar el descargo' }}
        </b>
      </h1>
      <small class="mb-4 italic opacity-80">
        <b>
          En esta sección, deberá justificar el cambio de estado del descargo.
        </b>
      </small>
    </div>
  </ng-template>

  <div class="w-full pt-3">
    <c-textarea
      placeholder="Ingrese la respuesta para el descargo"
      etiqueta="Respuesta"
      [(valor)]="respuesta"
      [showError]="error"
      mensajeError="Falta completar este campo"
    />
  </div>

  <br />
  <div class="flex justify-end">
    <petrol-button variant="primary" (click)="setValues()">Confirmar</petrol-button>
  </div>
</p-dialog>

<c-dialog #dialog />
}
